import { ConfiguredServiceFormPage } from "./ConfiguredServiceFormPage";
import { signatureHighlightReelFormConfig } from "./configuredServiceForms";

export function SignatureHighlightReelFormPage() {
  return <ConfiguredServiceFormPage config={signatureHighlightReelFormConfig} />;
}
